// camel.pipe.ts

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'camel'})
export class CAMELPipe implements PipeTransform {
  transform(string) {
    return string.toLowerCase().replace(/(^|\s)\S/g, function(t) { return t.toUpperCase() });
  }
}